interface TitreDocumentProps {
  /** The title of the document, as the history and the translation know it; none: nothing is shown. */
  titre?: string | undefined;
}

/**
 * The title of the translated document, between the header and the main content of the result
 * (#31) and of the analysis (#30), the same component on both: the one the user gave (the
 * history shows it too, no further call to Tahiti). One line: a long title is cut with an
 * ellipsis, and the whole title stays in the page for the screen readers (the cut is only the
 * look) and in `title` for a pointer. Not a heading: each page has its `h1` ("Analyse des
 * modifications", "Votre texte traduit") and the `h2` of its sections, and a title of document
 * is data, not a section. Without a title (the document has none, or an empty one) nothing is
 * shown: no "Sans titre" and no hole.
 */
export function TitreDocument({ titre }: TitreDocumentProps) {
  const nom = titre?.trim();
  if (nom === undefined || nom === '') return null;
  return (
    <p title={nom} data-titre-document="" className="mt-6 truncate text-black text-h4">
      {nom}
    </p>
  );
}
